import { config } from '../_config';
import { authHeader, handleResponse } from '../_helpers';

export const copropSvr = {
    acBuscarUsuarioPorDni
}

function acBuscarUsuarioPorDni(dni) {
    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...authHeader()
        },
        body: JSON.stringify(dni)
      };
      return fetch(`${config.apiUrl}/findNameByDni`, requestOptions).then(handleResponse);
}